import axios from "axios";
import type { ApiResult, CarBrandDto, CarModelDto } from "../types/car.types";

const baseURL = process.env.REACT_APP_API_BASE_URL ?? "https://apidc.dubaitravelexpert.ae";
const api = axios.create({ baseURL });

export const carApi = {
  getBrands: () =>
    api.get<ApiResult<CarBrandDto[]>>("/v1/Car/Brand/Search").then((r) => r.data),

  getModelsByBrandId: (brandId: string) =>
    api
      .get<ApiResult<CarModelDto[]>>(`/v1/Car/Model/Search/${brandId}`)
      .then((r) => r.data),

  getModelImageUrl: (imageId: string) =>
    `${baseURL || ""}/v1/Car/Model/Image/${imageId}`,
};
